import { createContext, useCallback, useState, useEffect, useMemo } from "react";
import { setToastHandler } from "../utils/toastService";
import Toast from "../components/Toast";

export const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    type: "error",
  });

  const showToast = useCallback((message, options = {}) => {
    setToast({
      visible: true,
      message,
      type: options.type || "error",
    });

    setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, options.duration || 2000);
  }, []);

  useEffect(() => {
    setToastHandler(showToast);
  }, [showToast]);

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={value}>
      <Toast {...toast} />
      {children}
    </ToastContext.Provider>
  );
};
